"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** Replaced by the value in package.json on build */
exports.default = "2.7.2";
//# sourceMappingURL=sdkVersion.js.map